import { render, staticRenderFns } from "./AsideMenuPublic.vue?vue&type=template&id=653ae587&"
import script from "./AsideMenuPublic.vue?vue&type=script&lang=js&"
export * from "./AsideMenuPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports